import ReviewServicesPageContainer from './ReviewServicesPageContainer';

export default ReviewServicesPageContainer;



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/ReviewServicesPage/index.js